import {
  handleCatchErrors,
  responseDataFormatRedux,
} from "../../middlewares/resolveRequests";
import {
  addAssignment,
  addResponse,
  getAllAssignments,
  getAllResponse,
  getAssignment,
  updateAssignment,
} from "../../services/PresidentialAssignment";
import * as actionTypes from "./actionTypes";

export const getAllAssignmentsAPI = async (
  communityID,
  pageNumber,
  pageSize,
  data,
  token,
) => {
  let response;
  try {
    response = await getAllAssignments(
      communityID,
      pageNumber,
      pageSize,
      data,
      token,
    );
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_ALL_ASSIGNMENTS);
  }
};
export const addAssignmentAPI = async (data, token) => {
  let response;

  try {
    response = await addAssignment(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.ADD_ASSIGNMENT);
  }
};
export const updateAssignmentAPI = async (data, token) => {
  let response;

  try {
    response = await updateAssignment(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.UPDATE_ASSIGNMENT);
  }
};
export const getAssignmentAPI = async (id, token) => {
  let response;

  try {
    response = await getAssignment(id, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_ASSIGNMENT);
  }
};

export const getAllAssignmentCommentsAPI = async (id, token) => {
  let response;
  try {
    response = await getAllResponse(id, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_ALL_COMMENTS);
  }
};
export const addAssignmentCommentAPI = async (owner, data, token) => {
  let response;

  try {
    response = await addResponse(owner, data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.ADD_COMMENT);
  }
};
